module.exports = __webpack_public_path__ + "static/media/informacoes.9ae77bf8.svg";